<div class="loader" *ngIf="isLoading">
  <svg class="circular" viewBox="25 25 50 50">
    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
  </svg>
</div>
<div class="item-content" #resizableDiv>
  <!-- NEED DEALER PLAN-->
  <div class="banner" *ngIf="currentDealerPlan === 1 && currentSitePlan != 4">
    <div class="banner-title"> 
      <div>💫 <b>Note</b>: Activating the <b>Video Vault Plus AI</b> plan unlocks <b>cloud-based AI filtering</b> of video clips for this site, enabling a more <b>accurate and efficient alarm response</b>.</div>
    </div>
  </div>
  <div class="plan-tab" *ngIf="isMainDealer">
    <div class="btn" *ngFor="let t of tabList" [class.btn-selected]="tab == t" [class.disabled]="isLoading" (click)="moveToTab(t)">
      <div class="tab-title">{{t}}</div>
      <div class="tab-selected-bar" *ngIf="tab == t"></div>
    </div>
  </div>
  <div #planContainer *ngIf="!isLoading">
    <div class="plan" [class]="getPlanStyle(1)" (mouseover)="tooltipCard(1)" (mouseout)="tooltipOutCard(1)">
      <div class="plan-top">
        <div class="title"> 
          <div>Basic</div>
          <div class="current-badge" *ngIf="currentSitePlan === 1">Current </div>
          <div class="next-month-badge" *ngIf="currentSitePlan != 1 && nextMonthSitePlan === 1">Next</div>
        </div>
        <div class="description">This plan provides basic alarm-based video storage.</div>
        <div class="price-area">
          <div class="baseline" *ngIf="isHasViewPricePermission">
            <div class="price" style="font-size: 16px;font-weight: 500;">No Charge</div>
          </div>
          <div class="btn-area" *ngIf="(currentSitePlan > 1 && nextMonthSitePlan != 1) && isHasEditPermission">
            <div class="button button-white" (click)="onClickSitePlanSave(1)">
              <div class="btn-inner">Downgrade</div>
            </div>
          </div>
        </div>
      </div>
      <div class="plan-bottom">
        <div class="key-feature"><i class="material-icons" [class]="getPlanStyle(1)">check</i>
          <div class="feature">Alarm-triggered video storage</div>
        </div>
        <div class="key-feature"><i class="material-icons" [class]="getPlanStyle(1)">check</i>
          <div class="feature">Automation video event storage</div>
        </div>
      </div>
      <tooltip-wrapper 
        [ngClass]="isShowCard[1] ? 'show' : 'hidden'" 
        [sitePlan]="1" 
        [currentDealerPlan]="currentDealerPlan" 
        [hasCHeKTBridge]="hasCHeKTBridge"
      >
      </tooltip-wrapper>
    </div>
    <div class="plan" [class]="getPlanStyle(2)" (mouseover)="tooltipCard(2)" (mouseout)="tooltipOutCard(2)">
      <div class="plan-top">
        <div class="title"> 
          <div>Video Vault</div>
          <div class="current-badge" *ngIf="currentSitePlan === 2">Current </div>
          <div class="next-month-badge" *ngIf="currentSitePlan != 2 && nextMonthSitePlan === 2">Next</div>
        </div>
        <div class="description">Access core features at a budget-friendly price.</div>
        <div class="price-area">
          <div class="baseline" *ngIf="isHasViewPricePermission">
            <div class="price">{{me()?.currency_symbol}}{{servicePricing?.videoVaultPlanFee || 0}}</div>
            <div style="margin-left: 5px; color: rgba(0, 0, 0, .6);">per site / month</div>
          </div>
          <ng-container *ngIf="!isSettingTab">
            <div class="--g-tooltip-content" *ngIf="(me().type === 2 && site?.dealer_type === 3) && isHasViewPricePermission" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin: 0">
              <div class="link" (click)="goToSitePlanPage()">(Review Reseller Cost)</div>
              <div class="--g-tooltip" style="text-transform: none">The Review Reseller Cost would be a link.</div>
            </div>
            <div class="btn-area" *ngIf="isShowUpdateButton(2, 'edit') && canEdit()">
              <div class="button button-white" (click)="onClickSitePlanSave(2)">
                <div class="btn-inner">{{ currentSitePlan < 2 ? 'Upgrade Plan' : 'Downgrade' }}</div>
              </div>
            </div>
            <div class="btn-area" *ngIf="isShowUpdateButton(2, 'keep')">
              <div class="button button-white" (click)="onClickSitePlanSave(2)">
                <div class="btn-inner">Keep This Plan</div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="plan-bottom" [class]="getPlanStyle(2)">
        <div class="key-feature"><i class="material-icons" [class]="getPlanStyle(2)">check</i>
          <div class="feature">24/7 Cloud-Based Event Recording*</div>
        </div>
        <div class="key-feature"><i class="material-icons" [class]="getPlanStyle(2)">check</i>
          <div class="feature">On-Board Device Storage Access</div>
        </div>
        <div class="annotation" *ngIf="isHasViewPricePermission">*{{servicePricing.videoEvent.free_package_amount.event}} Free &  {{me()?.currency_symbol}}{{servicePricing.videoEvent.paid_package_amount.price}}/{{servicePricing.videoEvent.paid_package_amount.event}} for additional Events</div>
      </div>
      <tooltip-wrapper 
        [ngClass]="isShowCard[2] ? 'show' : 'hidden'" 
        [sitePlan]="2" 
        [currentDealerPlan]="currentDealerPlan" 
        [hasCHeKTBridge]="hasCHeKTBridge"
      ></tooltip-wrapper>
    </div>
    <div class="plan" [class]="getPlanStyle(3)" (mouseover)="tooltipCard(3)" (mouseout)="tooltipOutCard(3)">
      <div class="plan-top">
        <div class="title"> 
          <div>Video Vault Plus</div>
          <div class="current-badge" *ngIf="currentSitePlan === 3">Current </div>
          <div class="next-month-badge" *ngIf="currentSitePlan != 3 && nextMonthSitePlan === 3">Next</div>
        </div>
        <div class="description">Enjoy all Vault features with predictable and stable costs.</div>
        <div class="price-area">
          <div class="baseline" *ngIf="isHasViewPricePermission">
            <div class="price">{{ me()?.currency_symbol }}{{ servicePricing?.videoVaultPlusPlanFee || 0}}</div>
            <div style="margin-left: 5px; color: rgba(0, 0, 0, .6);">per site / month</div>
          </div>
          <ng-container *ngIf="!isSettingTab">
            <div class="--g-tooltip-content" *ngIf="(me().type === 2 && site?.dealer_type === 3) && isHasViewPricePermission" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin: 0">
              <div class="link" (click)="goToSitePlanPage()">(Review Reseller Cost)</div>
              <div class="--g-tooltip" style="text-transform: none">The Review Reseller Cost would be a link.</div>
            </div>
            <div class="btn-area" *ngIf="isShowUpdateButton(3, 'edit') && canEdit()">
              <div class="button button-white" (click)="onClickSitePlanSave(3)">
                <div class="btn-inner">{{ currentSitePlan < 3 ? 'Upgrade Plan' : 'Downgrade' }}</div>
              </div>
            </div>
            <div class="btn-area" *ngIf="isShowUpdateButton(3, 'keep')">
              <div class="button button-white" (click)="onClickSitePlanSave(3)">
                <div class="btn-inner">Keep This Plan</div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="plan-bottom" [class]="getPlanStyle(3)">
        <div style="font-size: 14px">All Video Vault features, plus:</div>
        <div class="key-feature"><i class="material-icons" [class]="getPlanStyle(3)">check</i>
          <div class="feature">Unlimited Cloud Event Storage - (No overage charges)*</div>
        </div>
        <div class="key-feature"><i class="material-icons" [class]="getPlanStyle(3)">check</i>
          <div class="feature">Timelapse Service per Camera</div>
        </div>
        <div class="annotation">*AI filtering usage calculated at dealer level costs.</div>
      </div>
      <tooltip-wrapper 
        [ngClass]="isShowCard[3] ? 'show' : 'hidden'" 
        [sitePlan]="3" 
        [currentDealerPlan]="currentDealerPlan" 
        [moveToLeft]="!isIPad"
        [hasCHeKTBridge]="hasCHeKTBridge"
      ></tooltip-wrapper>
    </div>
    <div class="plan" [class]="getPlanStyle(4)" (mouseover)="tooltipCard(4)" (mouseout)="tooltipOutCard(4)">
      <div class="plan-top">
        <div class="title"> 
          <div>Video Vault Plus AI</div>
          <div class="current-badge" *ngIf="currentSitePlan === 4">Current </div>
          <div class="next-month-badge" *ngIf="currentSitePlan != 4 && nextMonthSitePlan === 4">Next</div>
        </div>
        <div class="description">Get full access to Vault’s features with enhanced stability for high-usage demands.</div>
        <div class="price-area">
          <div class="baseline" *ngIf="isHasViewPricePermission">
            <div class="price">{{ me()?.currency_symbol }}{{ servicePricing?.videoVaultPlusAIPlanFee || 0}}</div>
            <div style="margin-left: 5px; color: rgba(0, 0, 0, .6);">per site / month</div>
          </div>
          <ng-container *ngIf="!isSettingTab">
            <div class="--g-tooltip-content" *ngIf="(me().type === 2 && site?.dealer_type === 3) && isHasViewPricePermission" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin: 0">
              <div class="link" (click)="goToSitePlanPage()">(Review Reseller Cost)</div>
              <div class="--g-tooltip" style="text-transform: none">The Review Reseller Cost would be a link.</div>
            </div>
            <div class="btn-area" *ngIf="isShowUpdateButton(4, 'edit') && canEdit()">
              <div class="button button-white" (click)="onClickSitePlanSave(4)">
                <div class="btn-inner">{{ currentSitePlan < 4 ? 'Upgrade Plan' : 'Downgrade' }}</div>
              </div>
            </div>
            <div class="btn-area" *ngIf="isShowUpdateButton(4, 'keep')">
              <div class="button button-white" (click)="onClickSitePlanSave(4)">
                <div class="btn-inner">Keep This Plan</div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="plan-bottom" [class]="getPlanStyle(4)">
        <div style="font-size: 14px">All Video Vault features, plus:</div>
        <div class="key-feature"><i class="material-icons" [class]="getPlanStyle(4)">check</i>
          <div class="feature">Unlimited AI Usage - No overage</div>
        </div>
        <div class="key-feature"><i class="material-icons" [class]="getPlanStyle(4)">check</i>
          <div class="feature">All Inclusive Features</div>
        </div>
      </div>
      <tooltip-wrapper 
        [ngClass]="isShowCard[4] ? 'show' : 'hidden'" 
        [sitePlan]="4" 
        [currentDealerPlan]="currentDealerPlan" 
        [moveToLeft]="!isIPad" 
        [hasCHeKTBridge]="hasCHeKTBridge"
      >
      </tooltip-wrapper>
    </div>
  </div>
</div>
<app-notice *ngIf="m_notice.is_active" [modal]="m_notice" [tos]="tos" (event)="closedAgreementDialog($event)"></app-notice>
<dealer-cloud-ai-default-settings [modal]="m_cloud_ai_default_settings" (onUpdate)="applyDealerDeafaultCloudAISettings($event)"></dealer-cloud-ai-default-settings>